export type TBrandColor = string;

export type TBrandLogo = string;

export type TBrandTone =
  | "Inspirational"
  | "Informal"
  | "Innovative"
  | "Conversational"
  | "Bold";

export interface IColorPalette {
  name: string;
  primary: string;
  secondary: string;
  accent: string;
  background: string;
  text: string;
  explanation?: string;
}

export interface IBrandingSetupData {
  brandColor: TBrandColor;
  brandLogo: TBrandLogo;
  brandTone: TBrandTone;
  colorPalette?: IColorPalette;
  projectName?: string;
  projectDescription?: string;
  projectMotivation?: string;
}

export const defaultBrandingSetupData: IBrandingSetupData = {
  brandColor: "#3B82F6",
  brandLogo: "",
  brandTone: "Conversational",
};
